import React from 'react';
import { Box, Container, HStack, Icon, Image, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Box as="section" id="experiencias" bg="cream.100" py={{
    base: 14,
    md: 24
  }} data-id="element-181" data-mp="3b0ufhqotjg05">
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} data-id="element-182" data-mp="3ayqcdayqul0x">
        <SectionHeading eyebrow="Opiniones reales de consultas" title="EXPERIENCIAS DE NUESTROS CLIENTES" description="Comentarios compartidos por personas que nos han consultado. Las experiencias son personales y los resultados pueden variar según cada persona." data-id="element-183" data-mp="36zr0f6elhnzz" />
        <SimpleGrid columns={{
        base: 1,
        md: 3
      }} spacing={{
        base: 4,
        md: 6
      }} mt={{
        base: 10,
        md: 14
      }} data-id="element-184" data-mp="2s3081h3c9cjv">
          {testimonials.map(testimonial => <VStack key={testimonial.author} as="figure" align="flex-start" spacing={5} bg="white" border="1px solid" borderColor="cream.200" borderRadius="xl" p={{
          base: 6,
          md: 7
        }} h="100%" m={0} data-id="element-185" data-mp="qbn6n20kxmsk">
              <Icon as={QuoteIcon} boxSize="1.5rem" color="gold.400" aria-hidden="true" data-id="element-186" data-mp="c6loy2t4om59" />
              <Text as="blockquote" fontSize="md" color="plum.700" flex="1" fontStyle="italic" data-id="element-187" data-mp="zwponz3741qz">
                “{testimonial.quote}”
              </Text>
              <HStack as="figcaption" spacing={3} align="center" data-id="element-188" data-mp="14uzmyik7vigt">
                <Image src={testimonial.avatar} alt={`Retrato de ${testimonial.author}`} w="3rem" h="3rem" borderRadius="full" objectFit="cover" border="1px solid" borderColor="gold.200" loading="lazy" data-id="element-189" data-mp="q7eh4gvyj557" />
                <Box data-id="element-190" data-mp="1xhqw5jcmhird">
                  <Text fontSize="sm" fontWeight={600} color="plum.800" data-id="element-191" data-mp="1xgxxz6rqc1ku">
                    {testimonial.author}
                  </Text>
                  <Text fontSize="xs" color="plum.400" letterSpacing="0.08em" textTransform="uppercase" data-id="element-192" data-mp="1sgtgbdf350t1">
                    {testimonial.meta}
                  </Text>
                </Box>
              </HStack>
            </VStack>)}
        </SimpleGrid>
      </Container>
    </Box>;
}